import React from 'react';
import { formaPagamentoLabel } from '../constants';
import { StyledCard, CardTitle } from '../cardStyles';
import { InfoRow, SectionLabel } from '../style';

interface Props {
  invoice: any;
  readOnly?: boolean;
}

const formatBrl = (val: number) =>
  val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const PagamentoSection: React.FC<Props> = ({ invoice }) => {
  const snapshotFormas = invoice?.InvoicePayment ?? [];
  const snapshotParcelas = invoice?.InvoiceInstallment ?? [];
  const orderFormas = invoice?.Order?.OrderPaymentMethod ?? [];
  const orderParcelas = invoice?.Order?.OrderInstallment ?? [];
  const condicao = invoice?.condicaoPagamento || invoice?.Order?.PaymentCondition?.name;
  const isAVista = invoice?.condicaoPagamento === 'A_VISTA' || /vista/i.test(condicao || '');

  const formasExibidas = snapshotFormas.length > 0 ? snapshotFormas : null;
  const parcelasExibidas =
    snapshotParcelas.length > 0 ? snapshotParcelas : isAVista ? [] : orderParcelas;

  const condicaoLabel = isAVista
    ? 'À vista'
    : condicao === 'A_PRAZO'
    ? 'A prazo'
    : condicao || '—';

  return (
    <StyledCard>
      <CardTitle>Pagamento</CardTitle>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', fontSize: '13px' }}>
        <InfoRow>
          <span style={{ color: '#666' }}>Condição</span>
          <strong>{condicaoLabel}</strong>
        </InfoRow>

        <div>
          <SectionLabel>Formas</SectionLabel>
          <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {formasExibidas ? (
              formasExibidas.map((pg: any) => (
                <InfoRow key={pg.id}>
                  <span>{formaPagamentoLabel(pg.PaymentMethod?.name, pg.paymentMethodId)}</span>
                  <strong>{formatBrl(Number(pg.valor || 0))}</strong>
                </InfoRow>
              ))
            ) : orderFormas.length > 0 ? (
              orderFormas.map((opm: any, i: number) => (
                <InfoRow key={i}>
                  <span>{formaPagamentoLabel(opm.PaymentMethod?.name, opm.paymentMethodId)}</span>
                  <span style={{ fontSize: '11px', color: '#999' }}>valor definido na emissão</span>
                </InfoRow>
              ))
            ) : (
              <div style={{ fontSize: '12px', color: '#999' }}>Sem formas registradas</div>
            )}
          </div>
        </div>

        {parcelasExibidas.length > 0 && (
          <div>
            <SectionLabel>Parcelas</SectionLabel>
            <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {parcelasExibidas.map((parc: any, i: number) => (
                <InfoRow key={parc.id ?? i}>
                  <span>
                    {(parc.numeroParcela ?? parc.numero ?? i + 1)}ª —{' '}
                    {parc.vencimento
                      ? new Date(parc.vencimento).toLocaleDateString('pt-BR')
                      : '—'}
                  </span>
                  <span>{formatBrl(Number(parc.valorParcela ?? parc.valor ?? 0))}</span>
                </InfoRow>
              ))}
            </div>
          </div>
        )}
      </div>
    </StyledCard>
  );
};

export default PagamentoSection;
